const Icon = ({ name, className = '', ...props }) => (
  <i className={`iconfont ${name} ${className}`} {...props} />
);

export default Icon;
